import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL} from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";

const StaffPrivateRoute = ({ component: Component }) => {
    const userData = getUser(ROLE.STAFF)
    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token){
                    return <Component/>
                }else{
                    setReturnURL(ROLE.STAFF);
                    return <Navigate to="/restaurant/login" />;
                }
            })()}
        </>
    )
}

export default StaffPrivateRoute;
